import { useState } from 'react';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@components/ui/button';
import { useGetWebPush } from '@services/webPushNotifications/get';
import { isPushSupported, readDismissed, saveDismissed } from './helpers';
import { usePushSubscription } from './usePushSubscription';

export const PushNotifications = () => {
  const { t } = useTranslation('app');
  const { data } = useGetWebPush();
  const { status, enable } = usePushSubscription();
  const [dismissed, setDismissed] = useState(readDismissed);

  const dismiss = () => {
    saveDismissed();
    setDismissed(true);
  };

  if (!isPushSupported() || dismissed || !data) return null;
  if (Notification.permission === 'granted' && data.pushEnabled) return null;

  const message = {
    idle: t('navigation.push.info'),
    working: t('navigation.push.info'),
    blocked: t('navigation.push.blocked'),
    failed: t('navigation.push.failed'),
  }[status];

  const actionLabel = {
    idle: t('navigation.push.action'),
    working: t('navigation.push.working'),
    blocked: null,
    failed: t('navigation.push.retry'),
  }[status];

  return (
    <div className="bg-warning" role="status">
      <div className="container flex items-center gap-2 py-1 pl-4 pr-1 text-white">
        <span className="min-w-0 flex-1 font-inter text-sm font-medium leading-tight">
          {message}
        </span>
        {actionLabel && (
          <Button
            variant="secondary"
            size="sm"
            className="shrink-0"
            disabled={status === 'working'}
            onClick={() => void enable()}>
            {actionLabel}
          </Button>
        )}
        <button
          type="button"
          aria-label={t('navigation.push.dismiss')}
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md hover:bg-white/20"
          onClick={dismiss}>
          <X className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};
